import { IonRadio as IonicIonRadio } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const IonRadio = styled(IonicIonRadio)`
  --border-radius: 50%;
  --inner-border-radius: 50%;
  --color: ${myPalette.dark.main};
  --color-checked: ${myPalette.midnightBlue.main};
  --border-color: ${myPalette.dark.main};
  --border-color-checked: ${myPalette.midnightBlue.main};
  --border-width: 2px;
  --background: transparent;
  --background-checked: ${myPalette.midnightBlue.main};
  --ripple-color: ${myPalette.midnightBlue.main};

  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;

  &::part(container) {
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
  }

  &::part(inner) {
    width: 12px;
    height: 12px;
    background: ${myPalette.white.main};
  }

  &:hover::part(container) {
    border-color: ${myPalette.midnightBlue.main};
  }

  &[disabled] {
    --color: ${myPalette.dark.main};
    --border-color: ${myPalette.dark.main};
    --background: ${myPalette.dark['100']};
    opacity: 0.5;
  }
`
